export default {"src":"/_next/static/media/arrow-up.c7400901.svg","height":15,"width":18};